import {defineMessages} from 'react-intl';

const messages = defineMessages({
  x_steps: {
    id: 'x_steps',
    defaultMessage: '{stepCount} {stepCount, plural, one {step} other {steps}}'
  },
  x_checks: {
    id: 'x_checks',
    defaultMessage: '{checkCount} {checkCount, plural, one {check} other {checks}}'
  }
});

export default messages;
